import { useTranslation } from 'react-i18next';

import { itemByLanguage } from '@/utils/language';

import { OrderByDirection, SortOptions } from '@/types';

import Constants from 'constants/index';

import { TranslationKey } from '@/i18n/i18n';

interface SortViewsState {
  chooseTemplateModal?: boolean;
  managePlanView?: boolean;
  myPlans?: boolean;
  reportsPlansView?: boolean;
  reportsTeamMembersTab?: boolean;
  reportsTeamMembersView?: boolean;
  reportsPlansPlanView?: boolean;
  manageQuizzes?: boolean;
}

interface SortOptionConfig {
  id: string;
  translationString: TranslationKey;
  value?: string;
  key?: string;
  direction?: OrderByDirection;
}

const sortOptionMap: Record<string, SortOptionConfig[]> = {
  myPlans: [
    {
      id: '1',
      translationString: 'TrainingPlans.filtering.dueDate',
      value: Constants.PLANS_SORT_OPTIONS.DUE_DATE,
      direction: 'asc',
      key: 'dueDate',
    },
    {
      id: '2',
      translationString: 'TrainingPlans.filtering.aToZ',
      value: Constants.PLANS_SORT_OPTIONS.A2Z,
      direction: 'asc',
      key: 'nameLocalLang',
    },
    {
      id: '3',
      translationString: 'TrainingPlans.filtering.zToA',
      value: Constants.PLANS_SORT_OPTIONS.Z2A,
      direction: 'desc',
      key: 'nameLocalLang',
    },
  ],
  manageQuizzes: [
    {
      id: '1',
      translationString: 'TrainingPlans.filtering.newest',
      value: Constants.PLANS_SORT_OPTIONS.NEWEST,
      key: 'created',
      direction: 'desc',
    },
    {
      id: '2',
      translationString: 'TrainingPlans.filtering.oldest',
      value: Constants.PLANS_SORT_OPTIONS.OLDEST,
      key: 'created',
      direction: 'asc',
    },
    {
      id: '3',
      translationString: 'TrainingPlans.filtering.aToZ',
      value: Constants.PLANS_SORT_OPTIONS.A2Z,
      key: 'nameLocalLang',
      direction: 'asc',
    },
    {
      id: '4',
      translationString: 'TrainingPlans.filtering.zToA',
      value: Constants.PLANS_SORT_OPTIONS.Z2A,
      key: 'nameLocalLang',
      direction: 'desc',
    },
  ],
  chooseTemplateModal: [
    {
      id: '1',
      translationString: 'TrainingPlans.filtering.newest',
      value: Constants.PLANS_SORT_OPTIONS.NEWEST,
      key: 'created',
      direction: 'desc',
    },
    {
      id: '2',
      translationString: 'TrainingPlans.filtering.aToZ',
      value: Constants.PLANS_SORT_OPTIONS.A2Z,
      key: 'nameLocalLang',
      direction: 'asc',
    },
    {
      id: '3',
      translationString: 'TrainingPlans.filtering.zToA',
      value: Constants.PLANS_SORT_OPTIONS.Z2A,
      key: 'nameLocalLang',
      direction: 'desc',
    },
  ],
  managePlanView: [
    {
      id: '1',
      translationString: 'TrainingPlans.filtering.aToZ',
      value: Constants.PLANS_SORT_OPTIONS.A2Z,
      key: 'displayName',
      direction: 'asc',
    },
    {
      id: '2',
      translationString: 'TrainingPlans.filtering.zToA',
      value: Constants.PLANS_SORT_OPTIONS.Z2A,
      key: 'displayName',
      direction: 'desc',
    },
    {
      id: '3',
      translationString: 'TrainingPlans.filtering.dueDate',
      value: Constants.PLANS_SORT_OPTIONS.DUE_DATE,
      key: 'dueDate',
      direction: 'asc',
    },
  ],
  reportsPlansView: [
    {
      id: '1',
      translationString: 'TrainingPlans.filtering.newest',
      value: Constants.PLANS_SORT_OPTIONS.NEWEST,
      key: 'createdDateTime',
      direction: 'desc',
    },
    {
      id: '2',
      translationString: 'TrainingPlans.filtering.oldest',
      value: Constants.PLANS_SORT_OPTIONS.OLDEST,
      key: 'createdDateTime',
      direction: 'asc',
    },
    {
      id: '3',
      translationString: 'TrainingPlans.filtering.aToZ',
      value: Constants.PLANS_SORT_OPTIONS.A2Z,
      key: 'nameLocalLang',
      direction: 'asc',
    },
    {
      id: '4',
      translationString: 'TrainingPlans.filtering.zToA',
      value: Constants.PLANS_SORT_OPTIONS.Z2A,
      key: 'nameLocalLang',
      direction: 'desc',
    },
  ],
  reportsTeamMembersTab: [
    {
      id: '1',
      translationString: 'Reports.filtering.aToZ',
      value: Constants.PLANS_SORT_OPTIONS.A2Z,
      key: 'displayName',
      direction: 'asc',
    },
    {
      id: '2',
      translationString: 'Reports.filtering.zToA',
      value: Constants.PLANS_SORT_OPTIONS.Z2A,
      key: 'displayName',
      direction: 'desc',
    },
    {
      id: '3',
      translationString: 'Reports.filtering.startDate',
      value: Constants.PLANS_SORT_OPTIONS.START_DATE,
      key: 'startDateTime',
      direction: 'desc',
    },
  ],
  reportsTeamMembersView: [
    {
      id: '1',
      translationString: 'TrainingPlans.filtering.aToZ',
      value: Constants.PLANS_SORT_OPTIONS.A2Z,
      key: 'searchableName',
      direction: 'asc',
    },
    {
      id: '2',
      translationString: 'TrainingPlans.filtering.zToA',
      value: Constants.PLANS_SORT_OPTIONS.Z2A,
      key: 'searchableName',
      direction: 'desc',
    },
    {
      id: '3',
      translationString: 'TrainingPlans.filtering.newest',
      value: Constants.PLANS_SORT_OPTIONS.NEWEST,
      key: 'sortableCreated',
      direction: 'desc',
    },
    {
      id: '4',
      translationString: 'TrainingPlans.filtering.oldest',
      value: Constants.PLANS_SORT_OPTIONS.OLDEST,
      key: 'sortableCreated',
      direction: 'asc',
    },
    {
      id: '5',
      translationString: 'TrainingPlans.filtering.dueDate',
      value: Constants.PLANS_SORT_OPTIONS.DUE_DATE,
      key: 'sortableDueDate',
      direction: 'asc',
    },
  ],
  reportsPlansPlanView: [
    {
      id: '1',
      key: 'displayName',
      value: Constants.PLANS_SORT_OPTIONS.A2Z,
      direction: 'asc',
      translationString: 'TrainingPlans.filtering.aToZ',
    },
    {
      id: '2',
      key: 'displayName',
      direction: 'desc',
      value: Constants.PLANS_SORT_OPTIONS.Z2A,
      translationString: 'TrainingPlans.filtering.zToA',
    },
    {
      id: '3',
      translationString: 'TrainingPlans.filtering.dueDate',
      value: Constants.PLANS_SORT_OPTIONS.DUE_DATE,
      key: 'dueDate',
      direction: 'asc',
    },
  ],

  default: [
    {
      id: '1',
      translationString: 'TrainingPlans.filtering.newest',
      value: Constants.PLANS_SORT_OPTIONS.NEWEST,
      key: 'createdDateTime',
      direction: 'desc',
    },
    {
      id: '2',
      translationString: 'TrainingPlans.filtering.oldest',
      value: Constants.PLANS_SORT_OPTIONS.OLDEST,
      key: 'createdDateTime',
      direction: 'asc',
    },
    {
      id: '3',
      translationString: 'TrainingPlans.filtering.aToZ',
      value: Constants.PLANS_SORT_OPTIONS.A2Z,
      key: 'nameLocalLang',
      direction: 'asc',
    },
    {
      id: '4',
      translationString: 'TrainingPlans.filtering.zToA',
      value: Constants.PLANS_SORT_OPTIONS.Z2A,
      key: 'nameLocalLang',
      direction: 'desc',
    },
  ],
};

export const useSortOptions = ({
  chooseTemplateModal = false,
  managePlanView = false,
  myPlans = false,
  reportsPlansView = false,
  reportsTeamMembersTab = false,
  reportsTeamMembersView = false,
  manageQuizzes = false,
  reportsPlansPlanView = false,
}: SortViewsState = {}): SortOptions[] => {
  const { t } = useTranslation();

  const key = Object.keys(sortOptionMap).find(
    optionKey =>
      (optionKey === 'chooseTemplateModal' && chooseTemplateModal) ||
      (optionKey === 'managePlanView' && managePlanView) ||
      (optionKey === 'myPlans' && myPlans) ||
      (optionKey === 'reportsPlansView' && reportsPlansView) ||
      (optionKey === 'reportsTeamMembersTab' && reportsTeamMembersTab) ||
      (optionKey === 'reportsTeamMembersView' && reportsTeamMembersView) ||
      (optionKey === 'reportsPlansPlanView' && reportsPlansPlanView) ||
      (optionKey === 'manageQuizzes' && manageQuizzes),
  );

  const sortOptions = sortOptionMap[key ?? 'default'] ?? [];

  return sortOptions.map(option => ({
    ...option,
    translationString: t(option.translationString),
  }));
};

/**
 * Returns the same object with an additional `nameLocalLang` property.
 *
 * This assumes it has a name object that follows the convention:
 * ```
 * {
 *   ...otherProperties
 *   name: {
 *     en: "english string"
 *     es: "spanish string"
 *   }
 * }
 * ```
 *
 * There's a helper type you can import called `AddSortFields`.
 */

export const addSortFields = <
  T extends {
    name?: Record<string, string>;
    created?: string;
    description?: Record<string, string>;
  },
>(
  item: T,
): AddSortFields<T> => ({
  ...item,
  createdDateTime: item.created ? new Date(item.created).getTime() : 0,
  nameLocalLang: item.name ? itemByLanguage(item.name) : '',
  // All localized description strings so search matches regardless of the
  // active language (the data-view filter handles array-valued fields).
  descriptionSearch: item.description ? Object.values(item.description) : [],
});

export type AddSortFields<T> = T & {
  nameLocalLang?: string;
  createdDateTime?: number;
  descriptionSearch?: string[];
};
